import { useCallback } from 'react';
import { Modal, Button } from '@/ui/components/base';
import { useStore } from '@/store/useStore';
import { formatCurrency } from '@/ui/lib/utils';
import './BetSelector.css';

interface BetSelectorProps {
    onClose: () => void;
    isOpen: boolean;
}

export const BetSelector = ({ onClose, isOpen }: BetSelectorProps) => {
    const bets = useStore((state) => state.bets);
    const currency = useStore((state) => state.currency);
    const setBet = useStore((state) => state.setBet);

    const handleSelect = useCallback(
        (bet: number) => {
            setBet(bet);
            onClose();
        },
        [setBet, onClose],
    );

    return (
        <Modal className="bets-selector" onClose={onClose} isOpen={isOpen}>
            <Modal.Content>
                <Modal.Header closable>Select Bet</Modal.Header>
                <Modal.Body>
                    <div className="bets-selector__body">
                        {bets.map((bet) => (
                            <Button
                                key={bet}
                                className="bets-selector__item"
                                variant="secondary"
                                rounding="large"
                                onClick={() => handleSelect(bet)}
                            >
                                {formatCurrency(bet, currency)}
                            </Button>
                        ))}
                    </div>
                </Modal.Body>
            </Modal.Content>
        </Modal>
    );
};
